import React           from 'react';
import PropTypes       from 'prop-types'
import PriceMatrixCell from 'pu-react/components/PriceMatrixCell';
import classnames      from 'classnames';

const PriceMatrixHead = (props) => {
  const text = d => `${d} ${d === 1 ? 'day' : 'days'}`;

  return (
    <thead>
      <tr>
        <th className="qty">Qty</th>
        {props.leadTimes.map(qty => <th key={qty}>{text(qty)}</th>)}
      </tr>
    </thead>
  );
};

PriceMatrixHead.defaultProps = {
  leadTimes: [],
};

const PriceMatrixBody = props => {
  return (
    <tbody>
      {props.quantities.map((qty, row) => (
        <PriceMatrixRow
          hiddenRow = {(props.rowSelected !== undefined && props.showSummary && props.rowSelected !== row)}
          key={row}
          quantity={qty}
          row={row}
          {...props} />
      ))}
    </tbody>
  );
}

PriceMatrixBody.propTypes = {
  quantities: PropTypes.array.isRequired,
  showSummary: PropTypes.bool.isRequired,
  rowSelected: PropTypes.number,
};


const PriceMatrixRow = (props) => {
  const MatrixCell = props.matrixCell ? props.matrixCell : PriceMatrixCell;
  return (
    <tr className={props.hiddenRow ? 'd-none' : ''}>
      <td className="qty">{props.quantity}</td>
      {props.leadTimes.map((leadTime, col) => (
        <MatrixCell
          key={col}
          leadTime={leadTime}
          prefix_name={props.prefix_name}
          col={col}
          {...props} />
      ))}
    </tr>
  );
};

PriceMatrixRow.defaultProps = {
  leadTimes: [],
};

PriceMatrixRow.propTypes = {
  quantity: PropTypes.number.isRequired,
  leadTimes: PropTypes.array.isRequired,
  hiddenRow: PropTypes.bool.isRequired,
}


const PriceMatrix = (props) => {
  const leadTimes = props.lineItem.lead_times;
  const quantities = props.lineItem.quantities;
  const cssClass = classnames('table table-bordered table-price-matrix', {
    'table-striped': props.tableStripe,
    'table-sm'     : props.tableSm,
  })

  const MatrixHead = props.matrixHead ? props.matrixHead : PriceMatrixHead;

  return (
    <div className="table-responsive">
      <table className={cssClass}>
        <MatrixHead leadTimes={leadTimes} />
        <PriceMatrixBody
          quantities={quantities}
          leadTimes={leadTimes}
          {...props} />
      </table>
    </div>
  );
};

PriceMatrix.defaultProps = {
  tableStripe: false,
  tableSm    : false,
  matrixHead : null,
}

PriceMatrix.propTypes = {
  lineItem: PropTypes.object.isRequired,
  showSummary: PropTypes.bool.isRequired,
  rowSelected: PropTypes.number,
  matrixHead: PropTypes.func,
}

export default PriceMatrix;
